/**
 * Display-name maps for stable backend codes (conditions, dietary flags, languages).
 *
 * Keep in sync with the backend constants:
 *  - DietPlanConditions.java
 *  - DietPlanTemplate.dietaryFlags (free-form but these are the documented values)
 *
 * Adding a new condition/flag here is purely cosmetic — the picker will fall back to the raw code
 * if a label is missing.
 */

export const CONDITION_LABELS = {
  hypothyroidism: 'Hypothyroidism',
  hyperthyroidism: 'Hyperthyroidism',
  hashimoto_thyroiditis: "Hashimoto's thyroiditis",
  diabetes_type_1: 'Type 1 Diabetes',
  diabetes_type_2: 'Type 2 Diabetes',
  prediabetes: 'Prediabetes',
  gestational_diabetes: 'Gestational diabetes',
  pcos: 'PCOS',
  pcod: 'PCOD',
  metabolic_syndrome: 'Metabolic syndrome',
  obesity: 'Obesity',
  pregnancy_trimester_1: 'Pregnancy — 1st trimester',
  pregnancy_trimester_2: 'Pregnancy — 2nd trimester',
  pregnancy_trimester_3: 'Pregnancy — 3rd trimester',
  lactation: 'Lactation',
  general_wellness: 'General wellness',
}

export const DIETARY_FLAG_OPTIONS = [
  { code: 'vegetarian', label: 'Vegetarian' },
  { code: 'non-vegetarian', label: 'Non-vegetarian' },
  { code: 'vegan', label: 'Vegan' },
  { code: 'jain', label: 'Jain' },
  { code: 'vegetarian-with-egg', label: 'Vegetarian (with egg)' },
  { code: 'gluten-free', label: 'Gluten-free' },
]

export const LANGUAGE_OPTIONS = [
  { code: 'en', label: 'English' },
  { code: 'hi', label: 'हिन्दी (Hindi)' },
  { code: 'kn', label: 'ಕನ್ನಡ (Kannada)' },
]

export function conditionLabel(code) {
  if (!code) return ''
  return CONDITION_LABELS[code] ?? code
}

export function languageLabel(code) {
  return LANGUAGE_OPTIONS.find((l) => l.code === code)?.label ?? code
}

export function dietaryFlagLabel(code) {
  return DIETARY_FLAG_OPTIONS.find((f) => f.code === code)?.label ?? code
}

/** Format a Quantity object into a short display string. */
export function formatQuantity(quantity) {
  if (!quantity) return ''
  if (quantity.displayString) return quantity.displayString
  const amount = quantity.amount
  const unit = quantity.unit ?? ''
  if (amount == null) return unit
  // Render whole numbers without a decimal point.
  const isWhole = Number.isInteger(amount) || Math.abs(amount - Math.round(amount)) < 1e-6
  const amountStr = isWhole ? String(Math.round(amount)) : String(amount)
  return unit ? `${amountStr} ${unit}` : amountStr
}
